export default __webpack_public_path__ + "static/media/checklist (1).3b7858a7.svg";